<template>
  <div
    v-if="selectExternalStatuses"
    class="d-flex align-items-center justify-content-start mb-1"
  >
    <v-select
      v-if="!dataLoad"
      v-model="showExternalStatuses"
      class="w-100"
      :options="externalStatuses"
      placeholder="Select External Statuses"
      label="text"
      multiple
      :searchable="true"
      :clearable="true"
      @input="handleExternalStatuses"
    />
  </div>
</template>

<script>
import VSelect from 'vue-select'

export default {
  components: {
    'v-select': VSelect,
  },
  props: {
    selectExternalStatuses: {
      type: Boolean,
      default: () => false,
    },
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    externalStatuses: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showExternalStatuses: '',
    }
  },
  methods: {
    handleExternalStatuses() {
      this.$router.push({
        query: { ...this.$route.query, external_status: this.showExternalStatuses },
      })
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
